import * as React from 'react';
import Slider from 'react-slick';
import Slide from './Slide';
import styles from './SliderMain.styl';
export const SliderMain = React.forwardRef((props, ref) => {
    const { activeSlide, photos, scale, ratioW, ratioH, onChange, updateCookies, showYoutube } = props;
    const [videoSrc, setVideoSrc] = React.useState('');
    const style = {
        cursor: scale > 1 ? 'move' : 'default'
    };
    const handleSlideChange = (currentSlide, nextSlide) => {
        if (photos[nextSlide].videoUrl) {
            setVideoSrc(`https://www.youtube.com/embed/${photos[nextSlide].videoUrl}`);
        }
        else {
            setVideoSrc(null);
        }
    };
    const settings = {
        beforeChange: handleSlideChange,
        afterChange: onChange,
        dots: false,
        arrows: false,
        infinite: true,
        initialSlide: activeSlide,
        slidesToScroll: 1,
        slidesToShow: 1,
        speed: 300,
        draggable: true,
        swipe: scale === 1
    };
    const imagesCache = [];
    const imagesCount = photos.length;
    const currentSlide = activeSlide;
    const prevSlide = (activeSlide - 1 % imagesCount + imagesCount) % imagesCount;
    const nextSlide = (activeSlide + 1 % imagesCount + imagesCount) % imagesCount;
    return (React.createElement("div", { className: styles.wrapper, style: style },
        React.createElement(Slider, { ...settings, ref: ref }, photos.map((image, index) => {
            const showImage = index === currentSlide || index === prevSlide || index === nextSlide || imagesCache[index] !== undefined;
            imagesCache[currentSlide] = image.imageUrlLarge;
            imagesCache[prevSlide] = image.imageUrlLarge;
            imagesCache[nextSlide] = image.imageUrlLarge;
            const slideProps = {
                ratioW,
                ratioH,
                scale: index === activeSlide ? scale : 1,
                imageUrl: image.imageUrlLarge,
                videoUrl: videoSrc,
                key: index,
                showYoutube: showYoutube,
                updateCookies: updateCookies
            };
            return showImage ? React.createElement(Slide, { ...slideProps, key: index }) : React.createElement("div", { key: index });
        }))));
});
